
/********************************
 * COMPILER UTILS
 *
 * These are useful functions used during compiling
 * time to build the pages.
 ******************************** */

import path from 'path';
import getConfig from 'next/config';
import { fetchJson, postJSON } from '../http';

const {
  serverRuntimeConfig: SERVER,
  publicRuntimeConfig: PUBLIC,
} = getConfig();

const CMS = 'cms';
const VS = 'v1';

export function fetchGet(endpoint, pkg = CMS, version = VS) {
  const url = PUBLIC.AMOS_URL?.replace(/\/$/, '') +
    '/' +
    path.join(
      pkg,
      version,
      endpoint
    ) +
    `${endpoint.includes('?') ? '&' : '?'}taid=${PUBLIC.AMOS_TAID}` +
    `&key=${PUBLIC.AMOS_PUBLIC_KEY}`;

  const options = {};
  return fetchJson(url, options);
}

export function fetchPost(endpoint, data = {}, pkg = CMS, version = VS) {
  if (typeof window !== 'undefined') {
    throw new Error("This function is server side only");
  }

  const url = PUBLIC.AMOS_URL?.replace(/\/$/, '') +
    '/' +
    path.join(
      pkg,
      version,
      endpoint
    );

  const options = {
    ...data,
    taid: SERVER.AMOS_TAID,
    private_key: SERVER.AMOS_PRIVATE_KEY
  };

  return postJSON(url, options);
}

export function fetchPostPublic(endpoint, data = {}, pkg = CMS, version = VS) {
  const url = PUBLIC.AMOS_URL?.replace(/\/$/, '') +
    '/' +
    path.join(
      pkg,
      version,
      endpoint
    );

  const options = {
    ...data,
    taid: PUBLIC.AMOS_TAID,
    key: PUBLIC.AMOS_PUBLIC_KEY
  };

  return postJSON(url, options);
}


